import React, { Component, Children } from "react";

const isTouch = () =>
  "ontouchstart" in window ||
  (navigator.msMaxTouchPoints || navigator.maxTouchPoints) > 2;

class PreserveDimensions extends Component {
  constructor() {
    super();
    this.state = {};
  }

  preserveSize = () => {
    // check if width was resized
    if (this.state.width !== document.body.clientWidth) {
      this.setState({
        width: document.body.clientWidth,
        height: window.innerHeight
      });
    }
  };

  componentDidMount = () => {
    if (!isTouch()) return;
    this.preserveSize();
    window.addEventListener("resize", this.preserveSize);
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.preserveSize);
  };

  render() {
    return (
      <div
        ref={dom => {
          this.dom = dom;
        }}
        style={{ height: this.state.height }}
        {...this.props}
      />
    );
  }
}

export default PreserveDimensions;



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/PreserveDimensions.js